
import type { Input } from 'valibot';
import { boolean, number, object, string, transformAsync } from 'valibot';

export const categoryObject = object({
  id: string(),
  name: string(),
  is_deleted: boolean(),
  post_count: number(),
})



export const categorySchema = transformAsync(categoryObject,
  async (input) => {
    return {
      ...input,
    };
  }
)

export type CategoryItemType = Input<typeof categorySchema>;